module.exports = __webpack_public_path__ + "img/ola.a721f442.png";